import {
  SET_SERVER_MESSAGE
} from "../application/types";
import {all, call, put, takeLatest} from "redux-saga/effects";
import {httpGet, httpPost, httpPut} from "../../utils/HttpClient";
import { 
  CREATE_PAGE_LAYOUT,
  IPageLayout, LOAD_PAGE_LAYOUTS, LoadPageLayoutsAction, 
  UPDATE_PAGE_LAYOUT, UpdatePageLayoutAction, createPageLayoutSuccess, loadPageLayoutsSuccess, updatePageLayoutSuccess 
} from "./actions";
import {displayError} from "../../utils/utils";
import { authService } from '../../index';

function* loadPageLayoutsSaga(action: LoadPageLayoutsAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, ok: boolean, status: number } = yield call(httpGet,
      `api/preferences/pageLayouts`,
      token
    );
    if (!response.ok) {
      const error: string = yield call([response, response.json]);
      yield (put(displayError(error)));
    } else {
      const layouts: IPageLayout[] = yield call([response, response.json]);
      yield put(loadPageLayoutsSuccess(layouts));
    }
  } catch (error) {
    yield put(displayError(error as string));
  }
}
export function* watchLoadPageLayoutsSaga() {
  yield takeLatest(LOAD_PAGE_LAYOUTS, loadPageLayoutsSaga);
}

function* updatePageLayoutSaga(action: UpdatePageLayoutAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, ok: boolean, status: number } = yield call(httpPut,
      `api/preferences/pageLayouts`,
      action.payload.layout,
      token
    );
    if (!response.ok) {
      const error: string = yield call([response, response.json]);
      yield (put(displayError(error)));
    } else {
      yield put(updatePageLayoutSuccess(action.payload.layout));
    }
  } catch (error) {
    yield put(displayError(error as string));
  }
}
export function* watchUpdatePageLayoutSaga() {
  yield takeLatest(UPDATE_PAGE_LAYOUT, updatePageLayoutSaga);
}

function* createPageLayoutSaga(action: UpdatePageLayoutAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, ok: boolean, status: number } = yield call(httpPost,
      `api/preferences/pageLayouts`,
      action.payload.layout,
      token
    );
    if (!response.ok) {
      const error: string = yield call([response, response.json]);
      yield (put(displayError(error)));
    } else {
      const layout: IPageLayout = yield call([response, response.json]);
      yield put(createPageLayoutSuccess(layout));
    }
  } catch (error) {
    yield put(displayError(error as string));
  }
}
export function* watchCreatePageLayoutSaga() {
  yield takeLatest(CREATE_PAGE_LAYOUT, createPageLayoutSaga);
}


export default function* preferencesSagas() {
  yield all([
    watchLoadPageLayoutsSaga(),
    watchUpdatePageLayoutSaga(),
    watchCreatePageLayoutSaga()
  ]);
}